import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
    ArrowBackIos as BackButton,
} from '@mui/icons-material';
import { Autocomplete, Button, FormControl, FormLabel, InputLabel, MenuItem, Select, TextField, Typography } from "@mui/material";
import apiService from "../../../utlis/apiService";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import AdvancedFormat from 'dayjs/plugin/advancedFormat';
import dayjs from 'dayjs';
import 'dayjs/locale/en'; 
import { getSessions, generateYears } from "../../../utlis/commonFunction";
import { debounce } from "lodash";

dayjs.extend(AdvancedFormat);

function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
}

const CreateExamForm = () => {
    let query = useQuery();
    let id = query.get("id")
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: '',
        subject: '',
        examType: '',
        totalMark: '',
        passMark: '',
        batch: '',
        session: '',
        status: '',
        year: '',
    });
    const [subjects, setSubjects] = useState([]);
    const [batches, setBatches] = useState([]);
    const [selectedBatche, setSelectedBatch] = useState(null);
    const [searchSubject, setSearchSubject] = useState('');
    const [searchBatch, setSearchBatch] = useState('');
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({
        name: '',
        subject: '',
        date: null,
        examType: '',
        totalMark: '',
        passMark: '',
        batch: '',
        session: '',
        year: '',
    });

    const sessions = getSessions();
    const years = generateYears();

    const fetchExamData = async () => {
        try {
            if (id) {
                const response = await apiService.get('/exam/get', {
                    params: {
                        id: id,
                    },
                });
                setFormData((prevData) => ({
                    ...prevData,
                    ...response?.data,
                    batch: response?.data?.batch?._id,
                }));
                setSelectedBatch(response?.data?.batch);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const fetchSubject = async (query) => {
        setLoading(true);
        try {
            const response = await apiService.get('/paper/list', {
                params: {
                    searchTerm: query,
                },
            });
            setSubjects(response?.data?.papers ?? []);

        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const fetchBatch = async (query) => {
        try {
            setLoading(true);
            const response = await apiService.get('/batch/list', {
                params: {
                    searchTerm: query,
                    type: 'exam'
                },
            });

            setBatches(response?.data?.batchs ?? []);

        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchExamData();
    }, [id]);

    useEffect(() => {
        fetchSubject(searchSubject);
    }, [searchSubject]);

    useEffect(() => {
        fetchBatch(searchBatch);
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleDateChange = (date) => {
        setFormData((prevData) => ({
            ...prevData,
            date: date,
        }));
    }

    const handleChangeSubmit = (e, value, name) => {
        setFormData((prevData) => ({
            ...prevData,
            [name]: value?._id,
        }));
        if(name === 'batch') {
            setSelectedBatch(value);
        }
    };

    const handleYearChange = (e, value, name) => {
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSearchSubjectOptionChange = (event, newQuery) => {
        setSearchSubject(newQuery);
        setSubjects([]);
    }

    const debouncedFetchBatch = debounce((query) => {
        fetchBatch(query);
    }, 300);

    const handleSearchBatchOptionChange = (e, newQuery) => {
        if(e?.target?.value) {
            setSearchBatch(e?.target?.value);
            debouncedFetchBatch(newQuery);
        }
    }

    const validateForm = () => {
        let isValid = true;
        const newErrors = {
            name: '',
            subject: '',
            examType: '',
            totalMark: '',
            passMark: '',
            batch: '',
            session: '',
        };

        if(!formData.name){
            isValid = false;
            newErrors.name = 'Name is required';
        }
        if(!formData.subject){
            isValid = false;
            newErrors.subject = 'Subject is required';
        }
        if(!formData.examType){
            isValid = false;
            newErrors.examType = 'Exam Type is required';
        }
        if(!formData.totalMark){
            isValid = false;
            newErrors.totalMark = 'total Mark Type is required';
        }
        if(!formData.passMark){
            isValid = false;
            newErrors.passMark = 'Pass Mark Type is required';
        }

        setErrors(newErrors);
        return isValid;
    };
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log(formData);
    
        if (validateForm()) {
            const apiUrl = id ? `/exam/update?id=${id}` : '/exam/create';
    
            try {
                const response = await apiService.post(apiUrl, formData);
                navigate(-1);
                console.log(JSON.stringify(response.data));
            } catch (error) {
                alert(error?.response?.data?.error);
                console.error(error);
            }
        }
    };

    return (
        <div>
            <h1 style={{ cursor:'pointer', width: 'fit-content' }} onClick={() => navigate(-1)}>
                <BackButton />
                {`Exams`}
            </h1>
            <form onSubmit={handleSubmit}>
                <Typography variant="h4" gutterBottom>
                    {id ? 'Edit' : 'Create'} Exam
                </Typography>
                <TextField
                    label="Name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    fullWidth
                    required
                    margin="dense"
                    error={Boolean(errors.name)}
                    helperText={errors.name}
                    size='small'
                />
                <FormControl fullWidth sx={{ marginTop: '10px' }} size='small'>
                    <InputLabel id="Exam Type">Exam Type *</InputLabel>
                    <Select
                        label="Exam Type"
                        value={formData.examType}
                        onChange={handleChange}
                        fullWidth
                        name="examType"
                        required
                        error={Boolean(errors.examType)}
                        helperText={errors.examType}
                        size='small'
                    >
                        <MenuItem value="Main">Main</MenuItem>
                        <MenuItem value="Mock">Mock</MenuItem>
                    </Select>
                </FormControl>
                {formData.examType === 'Main' &&
                    <>
                        <FormControl fullWidth sx={{ marginTop: '10px' }} size='small'>
                            <InputLabel id="Session">Session *</InputLabel>
                            <Select
                                label="Session"
                                value={formData.session}
                                onChange={handleChange}
                                fullWidth
                                name="session"
                                required
                                size='small'
                            >
                                {sessions?.map((session, index) => (
                                    <MenuItem key={index} value={session}>{session}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <Autocomplete
                            id="combo-box-year"
                            required
                            options={years}
                            style={{ marginTop: '10px' }}
                            getOptionLabel={(option) => option}
                            value={years.find((option) => option === formData.year) || null}
                            onChange={(e, value) => handleYearChange(e, value, 'year')}
                            size='small'
                            renderInput={(params) => <TextField {...params} required label="Year" size='small' />}
                        />
                    </>
                }
                {formData.examType === 'Mock' &&
                    <Autocomplete
                        id="combo-box-batch"
                        required
                        loading={loading}
                        options={batches}
                        style={{ marginTop: '10px' }}
                        getOptionLabel={(option) => option.name}
                        value={selectedBatche}
                        onChange={(e, value) => handleChangeSubmit(e, value, 'batch')}
                        onInputChange={(e, value) => {
                            if(value !== searchBatch) {
                                handleSearchBatchOptionChange(e, value);
                            }
                        }}
                        size='small'
                        renderInput={(params) => <TextField {...params} label="Batch *" size='small' />}
                    />
                }
                <Autocomplete
                    disablePortal
                    id="combo-box-subject"
                    required
                    options={subjects}
                    style={{ marginTop: '10px' }}
                    getOptionLabel={(option) => option.name}
                    value={subjects.find((option) => option._id === formData.subject) || null}
                    onChange={(e, value) => handleChangeSubmit(e, value, 'subject')}
                    // onInputChange={handleSearchSubjectOptionChange}
                    size='small'
                    renderInput={(params) => <TextField {...params} label="Subject *" size='small' />}
                />
                <LocalizationProvider dateAdapter={AdapterDayjs} locale="en">
                    <FormControl className='gap-2 mb-8' fullWidth style={{ marginTop: 10 }}>
                        <MobileDatePicker
                            value={formData.date ? dayjs(formData.date) : null}
                            label="Select Date *"
                            onChange={(date) => handleDateChange(date)}
                            sx={{ marginTop: 1 }}
                            format="DD/MM/YYYY"
                            required
                            slotProps={{
                                textField: { size: 'small' }
                            }}
                        />
                    </FormControl>
                </LocalizationProvider>
                <TextField
                    label="Total Mark"
                    name="totalMark"
                    value={formData.totalMark}
                    onChange={handleChange}
                    fullWidth
                    required
                    error={Boolean(errors.totalMark)}
                    helperText={errors.totalMark}
                    margin="dense"
                    size='small'
                />
                <TextField
                    label="Pass Mark"
                    name="passMark"
                    value={formData.passMark}
                    onChange={handleChange}
                    fullWidth
                    required
                    error={Boolean(errors.passMark)}
                    helperText={errors.passMark}
                    margin="dense"
                    size='small'
                />
                <FormControl fullWidth style={{ marginTop: '10px'}} size='small'>
                    <InputLabel id="Status">Status</InputLabel>
                    <Select
                        label="Status"
                        name="status"
                        value={formData.status}
                        onChange={handleChange}
                        fullWidth
                        margin="dense"
                        size='small'
                    >
                        <MenuItem value="Active">Active</MenuItem>
                        <MenuItem value="Inactive">Inactive</MenuItem>
                        <MenuItem value="Cancelled">Cancelled</MenuItem>
                    </Select>
                </FormControl>

                <Button type="submit" variant="contained" color="primary" style={{ marginTop: '20px' }} size='small'>
                    {id ? 'Update Exam' : 'Create Exam' }
                </Button>
            </form>
        </div>
    );
}

export default CreateExamForm;